// CustomerTypePie.tsx
import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";
import '../Customers.scss'
import { formatNumber } from "../../../services/mixin";
import { Spin } from "antd";
import { useNavigate } from "react-router-dom";
import { IDataDefaulFilter } from "../ReportCustomer";


interface props {
    customerTypeData: any[]
    link: boolean
    dataFilter: IDataDefaulFilter
    showLoading: boolean
}

export const CustomerTypePie: React.FC<props> = ({ customerTypeData, showLoading, dataFilter, link }) => {
    const navigate = useNavigate()

    return (
        <div className="custom-page-css w-full flex h-full  flex-col justify-between items-center gap-6">
            <div className="custom-page-css w-240px h-240px">
                {showLoading ?
                    <ResponsiveContainer>
                        <PieChart>
                            <Pie
                                data={customerTypeData}
                                dataKey="value"
                                outerRadius={110}
                                paddingAngle={2}
                            >
                                {customerTypeData.map((entry, index) => (
                                    <Cell key={index} fill={entry.color}
                                        onClick={() => {
                                            link && navigate(
                                                `/analysis-report/customers-card-list`,
                                                {
                                                    state: {
                                                        firstPage: '/analysis-report/customers',
                                                        dataFilter,
                                                        typeBussiness: entry.type,
                                                        title: entry.type === 0 ? `Khách hàng là cá nhân` : `Khách hàng là doanh nghiệp`
                                                    }
                                                }
                                            )
                                        }}

                                    />
                                ))}
                            </Pie>
                        </PieChart>
                    </ResponsiveContainer>
                    :
                    <div
                        className='custom-page-css flex flex-col gap-2 items-center justify-center'
                        style={{ width: '100%', height: '100%' }}
                    >
                        <Spin size="default" />
                        <span>Đang tải...</span>
                    </div>
                }
            </div>

            {/* Legend */}
            <div className="space-y-2">
                {
                    customerTypeData.map((item) => {
                        const total = customerTypeData.reduce(
                            (s, i) => s + Number(i.value || 0),
                            0
                        )

                        const percent =
                            total === 0 ?
                                "0" :
                                ((Number(item.value || 0) / total) * 100).toFixed(1)
                        return (
                            <div key={item.name} className="flex items-center gap-2 text-sm">
                                <span
                                    className="w-3 h-3 rounded-sm"
                                    style={{ background: item.color }}
                                />
                                <span>
                                    {item.name}: {formatNumber(item.value ?? 0)} ({percent}%)
                                </span>
                            </div>
                        );
                    })
                }
            </div>
        </div>
    );
};
